import { render, staticRenderFns } from "./PermissionManagerPage.vue?vue&type=template&id=78de2149"
import script from "./PermissionManagerPage.vue?vue&type=script&lang=js"
export * from "./PermissionManagerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports